import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { ICompanySchemaPartial } from '../../type/company';

export interface IUpdateCompanyMarketCoverageMutationFields {
  _id: string;
  exportAreaAfrica: string[];
  exportAreaAmerica: string[];
  exportAreaAsia: string[];
  exportAreaEurope: string[];
  exportAreaOceania: string[];
  importAreaAfrica: string[];
  importAreaAmerica: string[];
  importAreaAsia: string[];
  importAreaEurope: string[];
  importAreaOceania: string[];
  serviceAreaAfrica: string[];
  serviceAreaAmerica: string[];
  serviceAreaAsia: string[];
  serviceAreaEurope: string[];
  serviceAreaOceania: string[];
}


export interface IUpdateCompanyMarketCoverageMutationResponseFields {
  updatedCompany: ICompanySchemaPartial;
}


export function updateCompanyMarketCoverageMutation(fragment: string): DocumentNode {
  return gql`
        mutation updateCompanyMarketCoverage (
        $_id: String!,
$exportAreaAfrica: [String],
$exportAreaAmerica: [String],
$exportAreaAsia: [String],
$exportAreaEurope: [String],
$exportAreaOceania: [String],
$importAreaAfrica: [String],
$importAreaAmerica: [String],
$importAreaAsia: [String],
$importAreaEurope: [String],
$importAreaOceania: [String],
$serviceAreaAfrica: [String],
$serviceAreaAmerica: [String],
$serviceAreaAsia: [String],
$serviceAreaEurope: [String],
$serviceAreaOceania: [String]
        ) {
        updateCompanyMarketCoverage (
        _id: $_id,
exportAreaAfrica: $exportAreaAfrica,
exportAreaAmerica: $exportAreaAmerica,
exportAreaAsia: $exportAreaAsia,
exportAreaEurope: $exportAreaEurope,
exportAreaOceania: $exportAreaOceania,
importAreaAfrica: $importAreaAfrica,
importAreaAmerica: $importAreaAmerica,
importAreaAsia: $importAreaAsia,
importAreaEurope: $importAreaEurope,
importAreaOceania: $importAreaOceania,
serviceAreaAfrica: $serviceAreaAfrica,
serviceAreaAmerica: $serviceAreaAmerica,
serviceAreaAsia: $serviceAreaAsia,
serviceAreaEurope: $serviceAreaEurope,
serviceAreaOceania: $serviceAreaOceania
        ) {
        ...fragment
        }
        }
        fragment fragment on UpdateCompanyMarketCoverageMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUpdateCompanyMarketCoverageMutation<TData extends Partial<IUpdateCompanyMarketCoverageMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ updateCompanyMarketCoverage: TData },
        IUpdateCompanyMarketCoverageMutationFields>,
) {
  return useMutation<{ updateCompanyMarketCoverage: TData },
      IUpdateCompanyMarketCoverageMutationFields>(
        updateCompanyMarketCoverageMutation(fragment), options,
      );
}
